import DateFnsUtils from '@date-io/date-fns';
import EventIcon from '@material-ui/icons/Event';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import classnames from 'classnames';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';

const YYYY_MM_DD_FORMAT = 'yyyy-MM-dd';
// use this when format is ^^^^
function dateToLocal(value) {
    if (!value) {
        return null;
    }

    const [year, month, day] = value.split('-');

    return `${month}/${day}/${year}`;
}

const DatePicker = React.forwardRef(
    (
        {
            className,
            onChange: onChangeCallback,
            valueFormat,
            value: valueProp,
            ...props
        },
        ref
    ) => {
        const dateFormat = valueFormat || props.format;
        const fixItFormat = dateFormat === YYYY_MM_DD_FORMAT;

        const value = React.useMemo(() => {
            if (valueProp) {
                // Covers an edge case where we have a corrupted date stored and returned. In this case, the date picker will display an empty date.
                if (
                    valueProp.day === 0 &&
                    valueProp.month === 0 &&
                    valueProp.year === 0
                ) {
                    return null;
                }

                if (valueProp.day && valueProp.month && valueProp.year) {
                    return `${valueProp.month}/${valueProp.day}/${valueProp.year}`;
                }
            }

            if (fixItFormat) {
                return dateToLocal(valueProp);
            }

            return valueProp;
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [valueProp]);

        const onChange = newValue => {
            if (newValue && newValue.toString() === 'Invalid Date') {
                return;
            }

            if (!newValue) {
                onChangeCallback(null);
                return;
            }

            onChangeCallback(format(newValue, dateFormat));
        };

        const attrs = {
            inputRef: ref,
            value,
            onChange,
            className: classnames(styles.root, className)
        };

        const styleName = props.disabled ? 'Read-only' : '';

        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    disableToolbar
                    {...props}
                    {...attrs}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                    keyboardIcon={<EventIcon className={styleName} />}
                />
            </MuiPickersUtilsProvider>
        );
    }
);

DatePicker.displayName = 'NeptuneDatePicker';

DatePicker.propTypes = {
    ...KeyboardDatePicker.propTypes,
    valueFormat: PropTypes.string
};

DatePicker.defaultProps = {
    valueFormat: null
};

export default DatePicker;
